import React from 'react';
import styled from 'styled-components';
import { mediaMax } from '../../Media Template/Media Template';
import {
  FlexContainer,
  Rating,
  Title,
  AuthorAndTime
} from '../../StyledComponents';

const StyledBannerDiv = styled.div.attrs({
  url: props => props.url,
  width: props => props.width
})`
  /* background: url(${props => props.url}); */
  background: linear-gradient(
      to bottom,
      rgba(238, 238, 238, 0),
      rgba(139, 139, 139, 0) 24%,
      rgba(33, 33, 33, 0.94) 81%
    ),
    url(${props => props.url});
    /* opacity:0.9; */

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: ${props => props.width};
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0 1.5rem;
  transition: all 0.3s;
  .BannerImage {
    position: absolute;
    height: 520px;
    z-index: -2;
  }
  .overlay-div {
    z-index:-1;
    position: absolute;
    background: black;
    opacity: 0;
    transition: 0.5s;
    cursor: pointer;
  }
  :hover > .overlay-div {
    opacity: 0.3 !important;
  }
  ${mediaMax.tablet`
    width: 100%;
  `};
`;

const bannerDivision = props => {
  // console.log('props: ', props);
  const { width, url, bannerClicked, postSlug } = props;
  const { postTitle, subTitle, rating, authorName, postDate } = props.postData;

  return (
    <StyledBannerDiv
      width={width}
      className="StyledBannerDiv pointer flex items-center"
      onClick={() => bannerClicked(postSlug)}
    >
      <StyledBannerDiv url={url} width={width} className="BannerImage" />
      <div
        className="overlay-div"
        style={{
          width: `${width}`,
          height: '520px'
        }}
      />
      <div style={{ paddingBottom: '1.75rem', maxWidth: '1040px' }}>
        <FlexContainer className="Title-Subtitle-Rating justify-between">
          <FlexContainer className="Title-And-Subtitle" direction="column">
            <Title
              fontFamily="Nunito"
              fontSize="1.875rem"
              fontWeight="bold"
              color="#fff"
              lineHeight="1.2"
            >
              {postTitle}
            </Title>
            {subTitle ? (
              <Title
                className="SubTitle"
                fontFamily="Montserrat"
                fontSize="1.25rem"
                fontstyle="italic"
                color="#fff"
              >
                {subTitle}
              </Title>
            ) : null}
          </FlexContainer>
          {rating ? (
            <FlexContainer className="Rating">
              <Rating
                width="75px"
                height="75px"
                padding="12px"
                background="#4db2ec"
              >
                <Title
                  className="Rating-Text"
                  fontFamily="Montserrat"
                  fontSize="2.25rem"
                  color="#fff"
                >
                  {rating}
                </Title>
              </Rating>
            </FlexContainer>
          ) : null}
        </FlexContainer>
        {authorName && postDate ? (
          <AuthorAndTime fontSize="0.75rem" color="#efefef">
            <div>{authorName}</div>
            <div>{postDate}</div>
          </AuthorAndTime>
        ) : null}
      </div>
    </StyledBannerDiv>
  );
};

export default bannerDivision;
